import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  LegalBasis,
  LegalBasisCreateRequest,
  LegalBasisCreateResponse,
  LegalBasisDetails,
  LegalBasisUpdateRequest,
  LegalBasisUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class LegalBasisService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/legal-basis/';
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<LegalBasis> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<LegalBasis>(url, request);
  }

  public getLegalBasis(): Observable<LegalBasis[]> {
    const url = this.endpoint;
    return this.httpClient.get<LegalBasis[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getLegalBasisById(id: number): Observable<LegalBasis> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<LegalBasis>(url);
  }

  public getLegalBasisDetails(id: number): Observable<LegalBasisDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<LegalBasisDetails>(url);
  }

  public deleteLegalBasis(id: number): Observable<LegalBasis> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<LegalBasis>(url);
  }

  public createLegalBasis(requestBody: LegalBasisCreateRequest): Observable<LegalBasisCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<LegalBasisCreateResponse>(url, requestBody);
  }

  public updateLegalBasis(id: number, requestBody: LegalBasisUpdateRequest): Observable<LegalBasisUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<LegalBasisUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
